import { defineStore } from 'pinia'

export const useWebTypeStore = defineStore('webType', {
    state: () => {
        return {
            isWX: false,
            isMobile: false,
        }
    },
    actions: {
        setWebType() {
            const ua = navigator.userAgent.toLowerCase()
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                this.isWX = true
            } else {
                this.isWX = false
            }
            if (ua.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i)) {
                this.isMobile = true
            } else {
                this.isMobile = false
            }
        }
    }
})
